import { Model } from 'dva'
import { OrganisationsService } from '../../../Service'
import { IsObject } from '../../../Utils/helpers'
import { FailureHandler } from 'Utils/ApiHelper'

const Utterances: Model = {
  namespace: 'utterances',
  state: {
    list: [],
  },
  effects: {
    *list(
      {
        useCache = true,
        additionalParams = {},
        setLoading = () => {},
        onSuccess = () => {},
        onFailure = () => {},
      },
      { call, put, select }
    ): any {
      setLoading(true)
      try {
        let organisationUuid = yield select(
          (state: any) => state.flowLayout.flow?.organisation?.uuid
        )
        let flowUuid = yield select((state: any) => state.flowLayout.flow?.uuid)
        let flowConfigVersion = yield select((state: any) => state.flowLayout?.version?.version)
        const flowConfig = yield select((state: any) => state.flowLayout?.version?.id)
        let utterances = yield call(
          OrganisationsService.organisationsFlowsVersionsUserUtterancesList,
          {
            organisationUuid,
            flowUuid,
            flowConfigVersion,
            flowConfig: [flowConfig],
          }
        )
        yield put({ type: 'modifyList', payload: utterances })
        onSuccess(utterances)
      } catch (err: any) {
        FailureHandler('Error fetching User Utterances', err, onFailure)
      }
      setLoading(false)
    },
    *retrieve(
      { id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ): any {
      setLoading(true)
      try {
        let organisationUuid = yield select(
          (state: any) => state.flowLayout.flow?.organisation?.uuid
        )
        let flowUuid = yield select((state: any) => state.flowLayout.flow?.uuid)
        let flowConfigVersion = yield select((state: any) => state.flowLayout?.version?.version)
        const flowConfig = yield select((state: any) => state.flowLayout?.version?.id)
        let response = yield call(
          OrganisationsService.organisationsFlowsVersionsUserUtterancesRetrieve,
          {
            organisationUuid,
            flowUuid,
            flowConfigVersion,
            id: id,
            flowConfig: [flowConfig],
          }
        )
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Could not find the Utternace!', err, onFailure)
      }
      setLoading(false)
    },
    *create(
      {
        data = {},
        additionalParams = {},
        setLoading = () => {},
        onSuccess = () => {},
        onFailure = () => {},
      },
      { call, put, select }
    ): any {
      setLoading(true)
      try {
        let organisationUuid = yield select(
          (state: any) => state.flowLayout.flow?.organisation?.uuid
        )
        let flowUuid = yield select((state: any) => state.flowLayout.flow?.uuid)
        let flowConfigVersion = yield select((state: any) => state.flowLayout?.version?.version)
        const flowConfig = yield select((state: any) => state.flowLayout?.version?.id)
        const response = yield call(
          OrganisationsService.organisationsFlowsVersionsUserUtterancesCreate,
          {
            organisationUuid,
            flowUuid,
            flowConfigVersion,
            requestBody: {
              name: data?.name,
              flow_config: flowConfig,
            },
          }
        )

        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error adding a Utternace!', err, onFailure)
      }
      setLoading(false)
    },
    *partialUpdate(
      { id, data, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ): any {
      setLoading(true)
      let organisationUuid = yield select((state: any) => state.flowLayout.flow?.organisation?.uuid)
      let flowUuid = yield select((state: any) => state.flowLayout.flow?.uuid)
      let flowConfigVersion = yield select((state: any) => state.flowLayout?.version?.version)
      try {
        const response = yield call(
          OrganisationsService.organisationsFlowsVersionsUserUtterancesPartialUpdate,
          {
            organisationUuid,
            flowUuid,
            flowConfigVersion,
            id: id,
            requestBody: data,
          }
        )
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error editing the Utterance!', err, onFailure)
      }
      setLoading(false)
    },
    *destroy(
      { id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ): any {
      setLoading(true)
      let organisationUuid = yield select((state: any) => state.flowLayout.flow?.organisation?.uuid)
      let flowUuid = yield select((state: any) => state.flowLayout.flow?.uuid)
      let flowConfigVersion = yield select((state: any) => state.flowLayout?.version?.version)
      try {
        yield call(OrganisationsService.organisationsFlowsVersionsUserUtterancesDestroy, {
          organisationUuid,
          flowUuid,
          flowConfigVersion,
          id: id,
        })
        yield put({ type: 'modifyList', payload: id })
        onSuccess()
      } catch (err) {
        FailureHandler('Error deleting the Utterance', err, onFailure)
      }
      setLoading(false)
    },
  },
  reducers: {
    modifyList(state, action) {
      // clone the list
      let list = [...state.list]
      if (IsObject(action.payload)) {
        // if the payload is an object, it's a single object, so add it to the list
        list = list.filter((l: any) => l.id !== action.payload.id)
        list.push(action.payload)
      } else if (Array.isArray(action.payload)) {
        // if the payload is an array, it's a list of objects, so add them to the list
        list = action.payload
      } else if (Number.isInteger(action.payload)) {
        // if the payload is an integer, it's an id sent in delete operations, so remove it from the list
        list = list.filter((l: any) => l.id !== action.payload)
      }
      return {
        ...state,
        list: list,
      }
    },
    resetUtterances(state, action) {
      return {
        ...state,
        list: [],
      }
    },
  },
}

export default Utterances
